module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-base/static-1.4844/img/video-thumb-overlay.png"